import React from 'react';

const LoadingSpinner = ({
  size = 'md',
  className = '',
  inline = false,
  fullScreen = true,
  label = 'Carregando dados',
  subtitle = '',
  cardClassName = '',
  flat = false
}) => {
  const sizeClasses = {
    sm: 'h-4 w-4',
    md: 'h-8 w-8',
    lg: 'h-12 w-12',
    xl: 'h-16 w-16'
  };

  if (inline) {
    return (
      <div className={`relative ${sizeClasses[size]} ${className}`}>
        <div className="absolute inset-0 rounded-full border-2 border-[color:var(--border)]"></div>
        <div className="absolute inset-0 rounded-full border-2 border-transparent border-t-[color:var(--accent)] animate-spin"></div>
      </div>
    );
  }

  const containerClasses = fullScreen
    ? `min-h-screen flex items-center justify-center px-6 py-10 ${className}`
    : `w-full flex items-center justify-center ${className}`;

  return (
    <div
      className={containerClasses}
      style={fullScreen ? { background: 'var(--bg)' } : undefined}
    >
      <div
        className={`w-full max-w-sm rounded-3xl px-6 py-5 text-left ${flat ? 'border-0 bg-transparent' : 'border border-[color:var(--border)] bg-[color:var(--surface)]'} ${cardClassName}`}
        style={flat ? undefined : { boxShadow: 'var(--shadow)' }}
      >
        <div className="flex items-center gap-4">
          <div className="loader-elegant" aria-hidden="true"></div>
          <div className="flex-1">
            <p className="text-sm font-semibold uppercase tracking-[0.18em] text-[color:var(--text-muted)]">
              {label}
            </p>
            {subtitle ? (
              <p className="mt-1 text-sm text-[color:var(--text-primary)]">
                {subtitle}
              </p>
            ) : null}
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoadingSpinner;
